module.exports = __webpack_public_path__ + "img/222A0721.a98d965b.png";